import { render } from "./index.vue?vue&type=template&id=42fd17b8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=42fd17b8&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42fd17b8"],['__file',"src/views/agreementCompany/people/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "42fd17b8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('42fd17b8', __exports__)) {
    console.log('reload')
    api.reload('42fd17b8', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=42fd17b8&scoped=true", () => {
    console.log('re-render')
    api.rerender('42fd17b8', render)
  })

}


export default __exports__